import { Config } from "@config";

export const MIN_CHILD_NUMBER = 0;
export const MAX_CHILD_NUMBER = 10;
export const MIN_AGES = 18;
export const MAX_AGES = 41;
export const MIN_LOAN_AMOUNT = 2_500_000;
export const MAX_LOAN_AMOUNT = 50_000_000;
export const MIN_LOAN_DURATION = 10;
export const MAX_LOAN_DURATION = 25;
export const MIN_MONTHLY_INCOME = Config.getMinWage();
export const MAX_MONTHLY_INCOME = 10_000_000;
export const MIN_REAL_ESTATE_VALUE = 0;

export const REQUEST_CONSULTANT_CALL_OPTIONS = [
	{
		label: "Kérem a Bankmonitor szakértőjének ingyenes segítségét a legolcsóbb megoldás megtalálásában",
		value: true,
	},
	{
		label: "Nem kérem az ingyenes tanácsadást",
		value: false,
	},
];
